const checkUserType = (userType) => {
	let allUserTypes = JSON.parse(localStorage.getItem('userInfo'))?.allUserTypes;
	return allUserTypes?.includes(userType);
};

const HTTP_STATUS = {
	OK: 200,
	'Bad Request': 400,
	Unauthorized: 401,
	Forbidden: 403,
	'Not Found': 404,
	'Method Not Allowed': 405,
	'Not Acceptable': 406,
	'Request Time-out': 408,
	Conflict: 409,
	Gone: 410,
	'Unsupported Media Type': 415,
	'Expectation Failed': 417,
	'Precondition Required': 428,
	'Valid OTP Exists': 452
};

export const BASE_URL = getBaseUrl(); //Live
export const BASE_FRONT_END_URL = getBaseFrontEndUrl();

export const LOADER_OVERLAY_BACKGROUND = 'transparent';
export const LOADER_COLOR = '#452D8D';
export const LOADER_WIDTH = '80px';
export const LOADER_TEXT = ''; //temporarily removed
export const LOADER_POSITION = 'fixed';
export const LOADER_TOP = '50%';
export const LOADER_LEFT = '50%';
export const LOADER_MARGIN_TOP = -100;
export const LOADER_MARGIN_LEFT = 0;

export const hjid = getHotjarId();
export const hjsv = 6;

function getHotjarId() {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 2748605;
	} else {
		return 2748605;
	}
}

export const PERMISSIONS = {
	COSTING_SHEET_ADD_FABRIC: 'COSTING_SHEET_ADD_FABRIC',
	COSTING_SHEET_ADD_QUANTITY: 'COSTING_SHEET_ADD_QUANTITY',
	COSTING_SHEET_APPROVE_OFFER: 'COSTING_SHEET_APPROVE_OFFER',
	COSTING_SHEET_GET: 'COSTING_SHEET_GET',
	COSTING_SHEET_DOWNLOAD: 'COSTING_SHEET_DOWNLOAD',
	COSTING_SHEET_PLACE_ORDER: 'COSTING_SHEET_PLACE_ORDER',
	COSTING_SHEET_REQUEST_FOR_RECOSTING: 'COSTING_SHEET_REQUEST_FOR_RECOSTING',
	COSTING_SHEET_UPDATE_BASE_PRICE: 'COSTING_SHEET_UPDATE_BASE_PRICE',
	COSTING_SHEET_UPDATE_PRICE: 'COSTING_SHEET_UPDATE_PRICE',
	COSTING_SHEET_UPDATE_REMARKS: 'COSTING_SHEET_UPDATE_REMARKS',
	MENU_DASHBOARD: 'MENU_DASHBOARD',
	MENU_QUOTES: 'MENU_QUOTES',
	MENU_ORDERS: 'MENU_ORDERS',
	MENU_NITEX_STUDIO: 'MENU_NITEX_STUDIO',
	MENU_COLLECTIONS: 'MENU_COLLECTIONS',
	MENU_INITIAL_COSTING: 'MENU_INITIAL_COSTING',
	MENU_RECOSTING: 'MENU_RECOSTING',
	SETTING_GET_GENERAL_SETTING: 'SETTING_GET_GENERAL_SETTING',
	MENU_SAMPLE: 'MENU_SAMPLE',
	MENU_PHOTOGRAPHY: 'MENU_PHOTOGRAPHY',
	MENU_PENDING_REQUESTS: 'MENU_PENDING_REQUESTS',
	MENU_MANAGE_REPORT: 'MENU_MANAGE_REPORT',
	MENU_SETTINGS: 'MENU_SETTINGS',
	MENU_SUPPLIER: 'MENU_SUPPLIER',
	MENU_MATERIAL: 'MENU_MATERIAL',
	MENU_CRM: 'MENU_CRM',
	COSTING_SHOW_PRICE_IN_DESIGN: 'COSTING_SHOW_PRICE_IN_DESIGN',
	MENU_ASSETS: 'MENU_ASSETS',
	MENU_CONFIGURATION: 'MENU_CONFIGURATION',
	MENU_TREND_RESEARCH: 'MENU_TREND_RESEARCH',
	MENU_MOOD_BOARD: 'MENU_MOOD_BOARD',

	MENU_MANAGE_USERS: 'MENU_MANAGE_USERS',
	MENU_MANAGE_ADMIN: 'MENU_MANAGE_ADMIN',
	MENU_MANAGE_CLIENT: 'MENU_MANAGE_CLIENT',
	MENU_MANAGE_ROLE: 'MENU_MANAGE_ROLE',
	MENU_MANAGE_BRAND: 'MENU_MANAGE_BRAND',
	MENU_MANAGE_SERVICES: 'MENU_MANAGE_SERVICES',
	MENU_MANAGE_DESIGN: 'MENU_MANAGE_DESIGN',
	MENU_MANAGE_ORDER: 'MENU_MANAGE_ORDER',
	MENU_MANAGE_INVOICE: 'MENU_MANAGE_INVOICE',
	MENU_MANAGE_COLLECTION: 'MENU_MANAGE_COLLECTION',
	MENU_MANAGE_TASK: 'MENU_MANAGE_TASK',
	MENU_MANAGE_BOOHOO_PO: 'MENU_MANAGE_BOOHOO_PO',
	MENU_MANAGE_ASSETS: 'MENU_MANAGE_ASSETS',
	MENU_MANAGE_CONFIGURATION: 'MENU_MANAGE_CONFIGURATION',
	MENU_MANAGE_SAMPLE: 'MENU_MANAGE_SAMPLE'
};

export const ROUTES = {
	MENU_DASHBOARD: '/dashboard',
	MENU_NITEX_STUDIO: '/nitex-studio',
	MENU_COLLECTIONS: '/collections/list',
	MENU_SAMPLE: '/sample/all',
	MENU_PHOTOGRAPHY: '/photography/all',
	MENU_MATERIAL: '/materials/view',
	MENU_DESIGNS: '/collections/list',
	MENU_ORDERS: '/orders/my-orders?active=ORDER_DASHBOARD',
	MENU_QUOTES: '/costing/initial',
	MENU_PENDING_REQUESTS: '/buyer-requests',
	MENU_SUPPLIER: '/suppliers/view',
	MENU_CRM: '/crm',
	MENU_ASSETS: '/assets',
	MENU_CONFIGURATION: '/configuration',
	MENU_TREND_RESEARCH: '/trends',
	MENU_MOOD_BOARD: '/moodboards',
	MENU_ADMIN_LIST: '/admins/list',
	MENU_CLIENT_LIST: '/clients/list',
	MENU_BRAND_LIST: '/brands/list',
	MENU_REPORTS: '/reports',
	MENU_LIBRARY_CONFIGURATION: '/configuration'
};

export const ALL_TOP_BAR_MENUS = [
	{
		key: 'MENU_DASHBOARD',
		permission: PERMISSIONS.MENU_DASHBOARD,
		route: ROUTES.MENU_DASHBOARD,
		activeTabKey: 'dashboard',
		title: checkUserType('COMMERCIAL') ? 'Commercial' : 'Dashboard'
	},
	{
		key: 'MENU_COLLECTIONS',
		permission: PERMISSIONS.MENU_COLLECTIONS,
		route: ROUTES.MENU_COLLECTIONS,
		activeTabKey: 'collections',
		title: 'Collections'
	},
	{
		key: 'MENU_MATERIAL',
		permission: PERMISSIONS.MENU_MATERIAL,
		route: ROUTES.MENU_MATERIAL,
		activeTabKey: 'materials',
		title: 'Materials'
	},
	{
		key: 'MENU_SAMPLE',
		permission: PERMISSIONS.MENU_SAMPLE,
		route: ROUTES.MENU_SAMPLE,
		activeTabKey: 'sample',
		title: 'Sample'
	},
	{
		key: 'MENU_PHOTOGRAPHY',
		permission: PERMISSIONS.MENU_PHOTOGRAPHY,
		route: ROUTES.MENU_PHOTOGRAPHY,
		activeTabKey: 'photography',
		title: 'Photoshoot'
	},
	{
		key: 'MENU_NITEX_STUDIO',
		permission: PERMISSIONS.MENU_NITEX_STUDIO,
		route: ROUTES.MENU_NITEX_STUDIO,
		activeTabKey: 'nitex-studio',
		title: 'Nitex Studio'
	},
	{
		key: 'MENU_ORDERS',
		permission: PERMISSIONS.MENU_ORDERS,
		route: ROUTES.MENU_ORDERS,
		activeTabKey: 'orders',
		title: 'Orders'
	},
	{
		key: 'MENU_QUOTES',
		permission: PERMISSIONS.MENU_QUOTES,
		route: ROUTES.MENU_QUOTES,
		activeTabKey: 'costing',
		title: 'Costing'
	},
	{
		key: 'MENU_PENDING_REQUESTS',
		permission: PERMISSIONS.MENU_PENDING_REQUESTS,
		route: ROUTES.MENU_PENDING_REQUESTS,
		activeTabKey: 'buyer-requests',
		title: 'Pending Requests'
	},
	{
		key: 'MENU_SUPPLIER',
		permission: PERMISSIONS.MENU_SUPPLIER,
		route: ROUTES.MENU_SUPPLIER,
		activeTabKey: 'suppliers',
		title: 'Suppliers'
	},
	{
		key: 'MENU_CRM',
		permission: PERMISSIONS.MENU_CRM,
		route: ROUTES.MENU_CRM,
		activeTabKey: 'crm',
		title: 'CRM'
	},
	{
		key: 'MENU_ASSETS',
		permission: PERMISSIONS.MENU_ASSETS,
		route: ROUTES.MENU_ASSETS,
		activeTabKey: 'assets',
		title: 'Assets'
	},
	{
		key: 'MENU_CONFIGURATION',
		permission: PERMISSIONS.MENU_CONFIGURATION,
		route: ROUTES.MENU_CONFIGURATION,
		activeTabKey: 'configuration',
		title: 'Configuration'
	},
	{
		key: 'MENU_TREND_RESEARCH',
		permission: PERMISSIONS.MENU_TREND_RESEARCH,
		route: ROUTES.MENU_TREND_RESEARCH,
		activeTabKey: 'trends',
		title: 'Trends'
	},
	{
		key: 'MENU_MOOD_BOARD',
		permission: PERMISSIONS.MENU_MOOD_BOARD,
		route: ROUTES.MENU_MOOD_BOARD,
		activeTabKey: 'moodboards',
		title: 'Mood Board'
	}
];

export const TOP_BAR_MORE_MENUS = [
	{
		label: 'Users',
		permission: PERMISSIONS.MENU_MANAGE_USERS,
		subMenus: [
			{
				label: 'Admins',
				to: ROUTES.MENU_ADMIN_LIST,
				permission: PERMISSIONS.MENU_MANAGE_ADMIN,
				key: 'admins'
			},
			{
				label: 'Clients',
				to: ROUTES.MENU_CLIENT_LIST,
				permission: PERMISSIONS.MENU_MANAGE_CLIENT,
				key: 'clients'
			},
			{
				label: 'Brands',
				to: ROUTES.MENU_BRAND_LIST,
				permission: PERMISSIONS.MENU_MANAGE_BRAND,
				key: 'brands'
			}
		]
	},
	{
		label: 'Services',
		permission: PERMISSIONS.MENU_MANAGE_SERVICES,
		subMenus: [
			{
				label: 'Sample',
				to: ROUTES.MENU_SAMPLE,
				permission: PERMISSIONS.MENU_MANAGE_SAMPLE,
				key: 'sample'
			},
			{
				label: 'Pending requests',
				to: ROUTES.MENU_PENDING_REQUESTS,
				permission: PERMISSIONS.MENU_PENDING_REQUESTS,
				key: 'pendingRequests'
			},
			{
				label: 'Costing',
				to: ROUTES.MENU_QUOTES,
				permission: PERMISSIONS.MENU_QUOTES,
				key: 'costing'
			},
			{
				label: 'Orders',
				to: ROUTES.MENU_ORDERS,
				permission: PERMISSIONS.MENU_ORDERS,
				key: 'orders'
			},
			{
				label: 'Trends',
				to: ROUTES.MENU_TREND_RESEARCH,
				permission: PERMISSIONS.MENU_TREND_RESEARCH,
				key: 'trends'
			},
			{
				label: 'Mood Board',
				to: ROUTES.MENU_MOOD_BOARD,
				permission: PERMISSIONS.MENU_MOOD_BOARD,
				key: 'moodboards'
			},
			{
				label: 'Collections',
				to: ROUTES.MENU_DESIGNS,
				permission: PERMISSIONS.MENU_MANAGE_COLLECTION,
				key: 'collections'
			},
			{
				label: 'Materials',
				to: ROUTES.MENU_MATERIAL,
				permission: PERMISSIONS.MENU_MATERIAL,
				key: 'materials'
			},
			{
				label: 'Suppliers',
				to: ROUTES.MENU_SUPPLIER,
				permission: PERMISSIONS.MENU_SUPPLIER,
				key: 'suppliers'
			},
			{
				label: 'Reports',
				to: ROUTES.MENU_REPORTS,
				permission: PERMISSIONS.MENU_MANAGE_REPORT,
				key: 'reports'
			}
		]
	},
	{
		label: 'Library',
		permissions: [PERMISSIONS.MENU_MANAGE_ASSETS, PERMISSIONS.MENU_MANAGE_CONFIGURATION],
		subMenus: [
			{
				label: 'Assets',
				to: ROUTES.MENU_ASSETS,
				permission: PERMISSIONS.MENU_MANAGE_ASSETS,
				key: 'assets'
			},
			{
				label: 'Configuration',
				to: ROUTES.MENU_LIBRARY_CONFIGURATION,
				permission: PERMISSIONS.MENU_MANAGE_CONFIGURATION,
				key: 'configuration'
			}
		]
	}
];

export const TAGS_TYPE = {
	MATERIAL_SUSTAINABLE_TAG: 'MATERIAL_SUSTAINABLE_TAG',
	SUPPLIER_STRENGTH: 'SUPPLIER_STRENGTH',
	SUPPLIER_ADDITIONAL_TAG: 'SUPPLIER_ADDITIONAL_TAG',
	SUPPLIER_CLIENTS: 'SUPPLIER_CLIENTS'
};

export const MATERIALS_TYPE = {
	GARMENTS: 'GARMENTS',
	FABRIC: 'FABRIC',
	MAIN_FABRIC: 'MAIN_FABRIC',
	EXTRA_FABRIC: 'EXTRA_FABRIC',
	EMBELLISHMENT: 'EMBELLISHMENT',
	TRIMS_ACCESSORIES: 'TRIMS_ACCESSORIES',
	BRANDING: 'BRANDING',
	WASHING: 'WASHING',
	TRIMS: 'TRIMS',
	ACCESSORIES: 'ACCESSORIES',
	DESIGN_FABRIC: 'DESIGN_FABRIC'
};

export const MATERIAL_TYPE = {
	GARMENT: 'GARMENT',
	MAIN_FABRIC: 'MAIN_FABRIC',
	EMBELLISHMENT: 'EMBELLISHMENT',
	TRIMS: 'TRIMS',
	BRANDING: 'BRANDING',
	ACCESSORIES: 'ACCESSORIES',
	LIBRARY_FABRIC: 'LIBRARY_FABRIC',
	WASHING_PROCESS: 'WASHING_PROCESS'
};

export const DEFAULT_SIZECATEGORY = {
	id: 1,
	name: 'Standard'
};

export const LIST_VIEW_TYPE = {
	LARGE_VIEW: 'LARGE_VIEW',
	NARROW_VIEW: 'NARROW_VIEW',
	IMAGE_VIEW: 'IMAGE_VIEW',
	LIST_VIEW: 'LIST_VIEW',
	CARD_VIEW: 'CARD_VIEW',
	COLLECTION_VIEW: 'COLLECTION_VIEW'
};

export const VALID_FILE_SIZE = 150582912; // in binary 150mb
export const MOODBAOD_PRESENTATION_IMAGE_SIZE = 5242880; // in binary 5mb
export const MOODBAOD_IMAGE_SIZE = 2097152; // in binary 2mb

export const PANTONE_OR_HEX_CODE = 'PANTONE_OR_HEX_CODE';
export const SWATCH = 'SWATCH';

export { HTTP_STATUS };

export const getSocketChannel = (userId) => {
	const hostName = window.location.toString();
	if (
		hostName.indexOf('https://admin.nitex.com') > -1 ||
		hostName.indexOf('https://admin-beta.nitex.com') > -1
	) {
		return `/topic/production-user-${userId}`;
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return `/topic/demo-user-${userId}`;
	} else {
		return `/topic/test-user-${userId}`;
	}
};

export const getCloudFrontUrl = () => {
	const hostName = window.location.toString();
	if (
		hostName.indexOf('https://admin.nitex.com') > -1 ||
		hostName.indexOf('https://admin-beta.nitex.com') > -1
	) {
		return 'https://d9nbihbmjte73.cloudfront.net';
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return 'https://d36qt47vlb2ajr.cloudfront.net';
	} else {
		return 'https://d2939dhdpmjcbe.cloudfront.net';
	}
};

export const getFileStorageUrl = () => {
	const hostName = window.location.toString();
	if (
		hostName.indexOf('https://admin.nitex.com') > -1 ||
		hostName.indexOf('https://admin-beta.nitex.com') > -1
	) {
		return 'https://gcpcdn.nitex.com';
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return 'https://filestorage-demo.nitex.com';
	} else {
		return 'https://filestorage-test.nitex.com';
	}
};

function getBaseUrl() {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://testadmin.nitex.com') > -1) {
		return 'https://testadmin.nitex.com/api/core';
	} else if (hostName.indexOf('https://testadmin-copy1.nitex.com') > -1) {
		return 'https://testadmin-copy1.nitex.com/api/core';
	} else if (hostName.indexOf('https://testadmin-copy2.nitex.com') > -1) {
		return 'https://testadmin-copy2.nitex.com/api/core';
	} else if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'https://admin.nitex.com/api/core';
	} else if (hostName.indexOf('localhost') > -1) {
		// return 'https://testadmin.nitex.com/api/core';
		// return 'https://testadmin-copy1.nitex.com/api/core';
		return 'https://testadmin-copy2.nitex.com/api/core';
	}
}

function getBaseFrontEndUrl() {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://testadmin.nitex.com') > -1) {
		return 'https://testadmin.nitex.com';
	} else if (hostName.indexOf('https://testadmin-copy1.nitex.com') > -1) {
		return 'https://testadmin-copy1.nitex.com';
	} else if (hostName.indexOf('https://testadmin-copy2.nitex.com') > -1) {
		return 'https://testadmin-copy2.nitex.com';
	} else if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'https://admin.nitex.com';
	} else if (hostName.indexOf('localhost') > -1) {
		return 'http://localhost:3000';
	}
}

export const isProductionServer = () => {
	const hostName = window.location.toString();
	if (
		hostName.indexOf('https://admin.nitex.com') > -1 ||
		hostName.indexOf('https://admin-beta.nitex.com') > -1
	) {
		return true;
	}
};

export function getOneSignalAppId() {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://admin-beta.nitex.com') > -1) {
		return 'dc4f825e-f9ab-4e68-b720-2173adb24b9d';
	} else if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'dc4f825e-f9ab-4e68-b720-2173adb24b9d';
	} else if (hostName.indexOf('https://demoadmin.nitex.com') > -1) {
		return '03cc5a15-1391-4e44-b983-a289141a7dad';
	} else {
		return '94cae871-cc52-4805-99a4-2184250b7422';
	}
}

export function getBaseWebSocketUrl() {
	const hostName = window.location.toString();
	if (hostName.indexOf('https://testadmin.nitex.com') > -1) {
		return 'wss://testadmin.nitex.com/api/core/ws';
	} else if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'wss://admin.nitex.com/api/core/ws';
	} else if (hostName.indexOf('localhost') > -1) {
		return 'wss://testadmin.nitex.com/api/core/ws';
	} else {
		return 'wss://testadmin.nitex.com/api/core/ws';
	}
}

export const getBuyerAppBaseFrontendUrl = () => {
	const hostName = window.location.toString();

	if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'https://app.nitex.com';
	} else {
		return 'https://test.nitex.com';
	}
};

export const supplierWorkflowSteps = {
	FACTORY_BASIC_INFORMATION: 'Factory Basic Information',
	PRODUCT_INFORMATION: 'Product Information',
	DOCUMENT_UPLOAD: 'Documents Upload',
	CAPACITY_INFORMATION: 'Capacity Information',
	BANK_INFORMATION: 'Bank Information'
};

export const supplierWorkflowFieldList = {
	FACTORY_BASIC_INFORMATION: [
		'name',
		'groupName',
		'establishmentYear',
		'factoryLocation',
		'officeLocation'
	],
	PRODUCT_INFORMATION: [
		'supplierTypeList',
		'supplierCategoryList',
		'productGroupIdList',
		'coreProductBaseTypeList',
		'productCategoryStrengthList',
		'technicalFacilities'
	],
	DOCUMENT_UPLOAD: [
		'additionalInformationDocumnetList',
		'tradeLicenseList',
		'factoryLicenseList',
		'tinCertificateList',
		'factoryCoverPhoto',
		'factoryPhotoList'
	],
	CAPACITY_INFORMATION: [
		'numberOfLine',
		'totalEmployee',
		'maleEmployeePercentage',
		'femaleEmployeePercentage',
		'knitting',
		'dyeing',
		'sewing',
		'washing',
		'sales'
	],
	BANK_INFORMATION: ['bankName', 'title', 'accountNumber', 'swiftCode', 'bankDetails', 'binNumber']
};

export const documentTypes = {
	additionalInformationDocumnetList: 'SUPPLIER_ADDITIONAL_INFORMATION',
	tradeLicenseList: 'SUPPLIER_TRADE_LICENSE',
	factoryLicenseList: 'SUPPLIER_FACTORY_LICENSE',
	tinCertificateList: 'SUPPLIER_TIN_CERTIFICATE',
	safetyDocument: 'SUPPLIER_SAFETY_DOCUMENT',
	factoryCoverPhoto: 'SUPPLIER_PHOTO_DOCUMENT',
	factoryPhotos: 'SUPPLIER_PHOTO_DOCUMENT',
	supportingDocument: 'SUPPLIER_SUPPORTING_DOCUMENT',
	supplierCertificate: 'SUPPLIER_CERTIFICATE'
};

export const TAG_COLOR_LIST = [
	'#DBFFE5',
	'#FFEAEA',
	'#FBD9C2',
	'#FEEAC1',
	'#DFF2FF',
	'#EDE3FE',
	'#D0F0FD',
	'#F4DBE6',
	'#C2F5E9',
	'#EDDBD5'
];

export const BRAND_OR_INFLUENCER_SLIDER_RESPONSIVE = [
	{ minWidth: 1520, maxWidth: 20000, slidesToShow: 8 },
	{ minWidth: 1440, maxWidth: 1519, slidesToShow: 6 },
	{ minWidth: 1365, maxWidth: 1439, slidesToShow: 5 },
	{ minWidth: 1024, maxWidth: 1364, slidesToShow: 4 },
	{ minWidth: 767, maxWidth: 1023, slidesToShow: 3 },
	{ minWidth: 500, maxWidth: 766, slidesToShow: 2 },
	{ minWidth: 0, maxWidth: 499, slidesToShow: 1 }
];

export const getSlidesToShowNumber = (windowWidth, screenList) => {
	let selectedScreen = screenList.find((item) => {
		if (item.minWidth <= windowWidth && item.maxWidth >= windowWidth) {
			return item;
		}
	});
	return selectedScreen.slidesToShow;
};

export const addressList = [
	{
		value: 'NIKETON OFFICE',
		id: 'H-15, R-8, Block-G, Niketon, Gulshan-1, Dhaka-1212, BD'
	},
	{
		value: 'GULSHAN OFFICE',
		id: 'House-07, Road-07, Gulshan-1, Dhaka-1212, Bangladesh'
	},
	{
		value: 'UK OFFICE',
		id: '151-153 Curtain Road, Bassmore House, Shoreditch, London EC2A 3QY, UK'
	},
	{
		value: 'TURKEY OFFICE',
		id: 'Halkalı Merkez , Çalışkan sok. No:1/6 Küçükçekmece / İstanbul'
	},
	{
		value: 'SINGAPORE OFFICE',
		id: '160 Robinson Road, #14-04, Singapore (068914)'
	}
];

export const myProfilePageTabs = [
	{ name: 'PersonalInformation', label: 'Personal information' },
	{ name: 'Strength', label: 'Soft & tech skills' },
	{ name: 'ChangePassword', label: 'Change password' },
	{ name: 'EmailPreferences', label: 'Preferences' },
	{ name: 'Signature', label: 'Signature' },
	{ name: 'MyColleagues', label: 'My colleagues' }
];
